var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.service
    ? _c("section", { staticClass: "py-3" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-6 offset-lg-3 col-12" }, [
            _c("div", {
              directives: [
                {
                  name: "lazy",
                  rawName: "v-lazy:background-image",
                  value: _vm.service.partner_picture
                    ? _vm.service.partner_picture
                    : _vm.service.picture,
                  expression:
                    "(service.partner_picture) ? service.partner_picture : service.picture",
                  arg: "background-image"
                }
              ],
              staticClass: "rounded bg-service",
              style: _vm.$mq.phone ? "height:220px" : "height:240px"
            }),
            _vm._v(" "),
            _c("div", { staticClass: "pt-3" }, [
              _c("img", {
                attrs: {
                  src: "/static/img/main-logo.svg",
                  alt: "",
                  width: "140"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "my-2" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm._f("multiLangName")(_vm.service)))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "main-content",
              domProps: {
                innerHTML: _vm._s(
                  _vm.currentLanguage === "th"
                    ? _vm.service.detail_th
                    : _vm.service.detail_en
                )
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "footer py-3 bg-white" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-lg-6 offset-lg-3 col-12" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-info btn-lg btn-block",
                    attrs: { to: _vm.bookingUrl }
                  },
                  [_vm._v("จองบริการ")]
                )
              ],
              1
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5be5ef8c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5be5ef8c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/ServiceDetail.vue
// module id = 2343
// module chunks = 0